import { Constants } from '@pwc/pwc-deals-web-common';
import _get from 'lodash/get';
import QofEBridgeChart from '../../../../../common/charts/types/QofEBridgeChart';
import DebtDebtLikeTable from '../../DebtDebtLike/DebtDebtLikeTable/DebtDebtLikeTable';
import NetWorkingCapitalChart from '../../NetWorkingCapital/charts/NetWorkingCapitalChart';
import NetWorkingCapitalTable from '../../NetWorkingCapital/NetWorkingCapitalTable/NetWorkingCapitalTable';
import QofETable from '../../QofE/QofETable/QofETable';

const NullComponent = () => null;
const tableComponent = 'tableComponent';
const chartComponent = 'chartComponent';

const structuredComponentToDocumentCodeMap = {
  [Constants.QUALITY_OF_EARNINGS]: {
    [tableComponent]: QofETable,
    [chartComponent]: QofEBridgeChart,
  },
  [Constants.NET_WORKING_CAPITAL]: {
    [tableComponent]: NetWorkingCapitalTable,
    [chartComponent]: NetWorkingCapitalChart,
  },
  [Constants.DEBT_AND_DEBT_LIKE]: {
    [tableComponent]: DebtDebtLikeTable,
    [chartComponent]: NullComponent,
  },
};

export const tableForDocumentCode = (documentCode) =>
  _get(
    structuredComponentToDocumentCodeMap,
    [documentCode, tableComponent],
    NullComponent
  );

export const chartForDocumentCode = (documentCode) =>
  _get(
    structuredComponentToDocumentCodeMap,
    [documentCode, chartComponent],
    NullComponent
  );
